import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@radix-ui/react-accordion';
import type { ReactNode } from 'react';

import { Icon } from '~/components';

interface AccordionContentBoxProps {
  title: string;
  children: ReactNode;
  defaultOpen?: boolean;
  className?: string;
  actions?: ReactNode;
  onValueChange?: (value: string) => void;
}

export function AccordionContentBox({
  title,
  actions,
  children,
  defaultOpen = true,
  className = '',
  onValueChange,
}: AccordionContentBoxProps) {
  const contentId = `accordion-content-${title.replace(/\s+/g, '-').toLowerCase()}`;

  return (
    <Accordion
      type="single"
      defaultValue={defaultOpen ? contentId : undefined}
      collapsible
      onValueChange={onValueChange}
    >
      <AccordionItem
        value={contentId}
        className={`flex flex-col gap-lg rounded-sm p-lg bg-level-02 ${className}`}
      >
        <div className="flex items-center justify-between">
          <AccordionTrigger>
            <div
              id={contentId}
              className="text-headline-sm font-semibold leading-tight"
            >
              {title}
            </div>
          </AccordionTrigger>

          <div className="flex items-center gap-md">
            {actions}
            <AccordionTrigger className="group">
              <Icon
                className="transition-transform group-data-[state=open]:rotate-180"
                type="chevron-down"
              />
            </AccordionTrigger>
          </div>
        </div>
        <AccordionContent>{children}</AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}

AccordionContentBox.displayName = 'AccordionContentBox';
